module.exports = __webpack_public_path__ + "img/BUNQ.34f6e184.jpg";